import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import DeleteIcon from "src/assets/all-icons/delete-icon.jsx";

import UserService from '@/services/user.service';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import PopupToBottomSheet from '@/shared-components/popups/components/PopupToBottomSheet';
import Text from '@/shared-components/text/components/Text';

import DeleteStickerPopup from './DeleteStickerPopup';

import './styles/AllStickersView.css';

export default function AllStickersView({ open, close, stickers: stickersProp, onDeleteSticker }) {
  const { user_username } = useParams();
  const location = useLocation();
  // Use stickers from props if available; fallback to location.state.
  const initialStickers = stickersProp || (location.state && location.state.stickers) || [];
  // Local state for stickers so deletion can update the view.
  const [localStickers, setLocalStickers] = useState(initialStickers);
  useEffect(() => {
    setLocalStickers(initialStickers);
  }, [initialStickers]);

  // State for the delete confirmation popup.
  const [deletePopupOpen, setDeletePopupOpen] = useState(false);
  // Store the index of the sticker to be deleted.
  const [stickerToDeleteIndex, setStickerToDeleteIndex] = useState(null);

  const handleDeleteClick = (index) => {
    setStickerToDeleteIndex(index);
    setDeletePopupOpen(true);
  };

  const confirmDelete = async () => {
    if (stickerToDeleteIndex === null) return;
    try {
      const toRemove = localStickers[stickerToDeleteIndex];
      // Ensure the item has an _id (provided by parent sticker mapping)
      if (toRemove?._id) {
        await UserService.deleteUserSticker(user_username, toRemove._id);
      }
      const newStickers = localStickers.filter((_, i) => i !== stickerToDeleteIndex);
      setLocalStickers(newStickers);
      // Notify parent so the slider/preview update too
      onDeleteSticker?.(newStickers);
    } catch (e) {
      console.error('[Stickers] Failed to delete sticker', e);
    } finally {
      setDeletePopupOpen(false);
      setStickerToDeleteIndex(null);
    }
  };

  return (
    <PopupToBottomSheet
      className="create-stickers-popup-bottom-sheet__container"
      open={open}
      close={close}
      popupOptions={{ opacity: true }}
    >
      <div className="create-stickers-popup__content-container">
        {/* Header */}
        <div className="create-stickers-popup__header">
          <div className="create-stickers-popup__header-content">
            <Text className="create-stickers-popup__header-text font-size-medium">
              My Stickers
            </Text>
          </div>
          <XIcon
            className="create-stickers-popup__close-button"
            onClick={close}
          />
        </div>

        {/* Sticker Grid Wrapper */}
        <div className="all-stickers-view__wrapper">
          <div className="all-stickers-view__container ReactVirtualized__Collection__innerScrollContainer">
            {localStickers.length > 0 ? (
              localStickers.map((sticker, index) => (
                <div
                  key={index}
                  className={`all-stickers-view__sticker-card ${
                    sticker.cropShape === 'circle'
                      ? 'all-stickers-view__sticker-card--circle'
                      : sticker.cropShape === 'brush'
                        ? 'all-stickers-view__sticker-card--brush'
                        : ''
                  }`}
                >
                  <div className="all-stickers-view__sticker-image-wrapper">
                    <ArtworkImage
                      image={sticker.imageId}
                      imageClassName={`all-stickers-view__sticker-image ${
                        sticker.cropShape === 'circle'
                          ? 'all-stickers-view__sticker-image--circle'
                          : ''
                      }`}
                      imageTemplateClassName={`all-stickers-view__sticker-image ${
                        sticker.cropShape === 'circle'
                          ? 'all-stickers-view__sticker-image--circle'
                          : ''
                      }`}
                      style={sticker.cropShape === 'brush' ? { objectFit: 'contain' } : {}}
                    />
                  </div>
                  <div
                    className="all-stickers-view__remove-button"
                    onClick={() => handleDeleteClick(index)}
                  >
                    <DeleteIcon className="all-stickers-view__remove-icon" />
                  </div>
                </div>
              ))
            ) : (
              <Text>Your stickers will buld up this view!</Text>
            )}
          </div>
        </div>
      </div>
      {deletePopupOpen && (
        <DeleteStickerPopup
          open={deletePopupOpen}
          close={() => setDeletePopupOpen(false)}
          onConfirm={confirmDelete}
        />
      )}
    </PopupToBottomSheet>
  );
}
